import './BrandPremise.css';

type BrandPremiseProps = {
    compact?: boolean;
    description?: string;
};

const BrandPremise = ({
    compact = false,
    description
}: BrandPremiseProps) => (
    <section className={`brand-premise ${compact ? 'compact' : ''}`.trim()}>
        <h1 id="truthpick-premise" aria-label="거짓이 진실을 덮는다.">
            <span>거짓이</span>
            <span className="brand-premise-truth">
                진실을
                <i aria-hidden="true" />
            </span>
            <span>덮는다.</span>
        </h1>
        {description && <p>{description}</p>}
    </section>
);

export default BrandPremise;
